module.exports = ".rowBorder {\n    border: 1px double rgba(211, 211, 211, 0.12);\n    background: rgba(211, 211, 211, 0.12);\n}\n\n#previewButton {\n    margin-top: 21px;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/config/mailConfig/mailTemplate.editor.component.css
 ** module id = 1057
 ** module chunks = 0
 **/